import script from "./ContactContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactContent.vue?vue&type=script&setup=true&lang=js"

import "./ContactContent.vue?vue&type=style&index=0&id=085c524c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-085c524c"]])

export default __exports__